/** API route map: URLS.Controller.PayrollPtoPolicy */
export const PayrollPtoPolicy = {
      Name: 'PayrollPtoPolicy/',
      Add: 'add',
      GetAll: 'get-all',
      Update: 'update',
      Delete: 'delete',
      Get: 'get',
      Employees: 'employees',
      AddEmployees: 'add-employees',
      RemoveEmployees: 'remove-employees',
};
